import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  user: {
    loggedIn: false,
    registered: false,
    email: null
  },
  build_dealer_config: "Chespik" /* GlobalMediaHubli , Chespik */,
  profiledata: {
    key: null,
    email: null,
    orderid: null,
    profileurl: null,
    firstname: null,
    lastname: null,
    phonenumber: null,
    whatsappnumber: null,
    designation: null,
    companyname: null,
    files: null,
    imageurl: null,
    imageext: null,
    facebooklink: null,
    instagramlink: null,
    linkedinlink: null,
    twitterlink: null,
    skypelink: null,
    companyinfo: null,
    companywebsite: null,
    paymentdetails: null,
    locationlink: null,
    profileinfo: null,
    milestones: null,
    awards: null,
    testimony: null,
    date: null,
    profiletype: null,
    subscriptiontype: null,
    userlinks: [null],
    expirydate: null,
    reserved: null,
    reserved1: null,
    reserved2: null,
    reserved3: null,
    reserved4: null,
    reserved5: null,
    reserved6: null,
    reserved7: null,
    reserved8: null,
    reserved9: null
  },
  error: null
};

const getters = {
  user(state) {
    return state.user;
  }
};

const mutations = {
  // Prasanna TODO :: The below state & mutations related to sidebar can be removed as sidebar navigation is disabled
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  SET_LOGGED_IN(state, value) {
    state.user.loggedIn = value;
  },
  SET_REGISTERED_IN(state, value) {
    state.user.registered = value;
  },
  SET_USER_EMAIL(state, email) {
    state.user.email = email;
  }
};

const actions = {
  async updateloginUser({ commit }, user) {
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(user.email, user.password);
      commit("SET_LOGGED_IN", user !== null);
      if (user !== null) {
        commit("SET_USER_EMAIL", user.email);
      } else {
        commit("SET_USER_EMAIL", null);
      }
    } catch (err) {
      state.error = err.message;

      commit("SET_LOGGED_IN", false);
    }
  },
  async updateRegisteredUser({ commit }, user) {
    try {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then(() => {});

      commit("SET_REGISTERED_IN", user !== null);
      if (user !== null) {
        commit("SET_USER_EMAIL", user.email);
      } else {
        commit("SET_USER_EMAIL", null);
      }
    } catch (err) {
      state.error = err.message;

      commit("SET_REGISTERED_IN", false);
    }
  }
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
});
